import { STATUS } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.niet_geanalyseerd;
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap font-mono text-[11px] uppercase tracking-wider px-2 py-0.5 rounded border ${s.cls}`}>
      {s.label}
    </span>
  );
};

const PRIO = { hoog: "text-rose-400", middel: "text-amber-400", laag: "text-slate-400" };
export const Prio = ({ value }) => (
  <span className={`font-mono text-[11px] uppercase tracking-wider ${PRIO[value] || PRIO.middel}`}>● {value || "middel"}</span>
);

export const PageTitle = ({ eyebrow, title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      <div className="font-mono text-[11px] tracking-widest text-blue-400 uppercase mb-2">{eyebrow}</div>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
